<template>
  <v-text-field
      v-model="displayValue"
      :disabled="loading"
      name="phone"
      type="tel"
      label="Номер телефона"
      @input="onInput"
      variant="outlined"
      density="comfortable"
      rounded="lg"
      placeholder="(___) ___-__-__"
      prepend-inner-icon="mdi-phone-outline"
      :rules="[v => !!v || 'Номер телефона обязателен']"
      class="mb-3"
  />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, nextTick } from "vue"

const props = defineProps({
  modelValue: {
    type: String,
    default: "+7",
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(["update:modelValue"])

const displayValue = ref(formatForDisplay(props.modelValue))

// отслеживаем внешние изменения
watch(
    () => props.modelValue,
    (newVal) => {
      if (newVal !== getRawValue(displayValue.value)) {
        displayValue.value = formatForDisplay(newVal)
      }
    }
)

function onInput(e) {
  const input = e.target
  const oldCursor = input.selectionStart

  // сохраняем количество цифр до курсора
  const digitsBeforeCursor = countDigits(displayValue.value.slice(0, oldCursor))

  // получаем "чистый" номер
  let raw = getRawValue(e.target.value)

  // ограничиваем длину до 11 цифр
  raw = raw.slice(0, 12)

  emit("update:modelValue", raw)

  // форматируем для отображения
  displayValue.value = formatForDisplay(raw)

  nextTick(() => {
    // вычисляем новую позицию курсора
    let newCursor = mapCursor(digitsBeforeCursor, displayValue.value)
    input.setSelectionRange(newCursor, newCursor)
  })
}

// посчитать количество цифр в строке
function countDigits(str) {
  return (str.match(/\d/g) || []).length
}

// возвращает "чистый" номер для v-model
function getRawValue(val) {
  const digits = val.replace(/\D/g, "")
  if (!digits.startsWith("7")) {
    return "7" + digits.slice(0, 10)
  }
  return digits.slice(0, 11)
}

// форматирование +7 (700) 123-45-67
function formatForDisplay(raw) {
  const digits = raw.replace(/\D/g, "")
  let res = "+7"
  if (digits.length > 1) res += " (" + digits.substring(1, 4)
  if (digits.length >= 4) res += ") " + digits.substring(4, 7)
  if (digits.length >= 7) res += "-" + digits.substring(7, 9)
  if (digits.length >= 9) res += "-" + digits.substring(9, 11)
  return res
}

// вычисление позиции курсора после форматирования
function mapCursor(digitIndex, formatted) {
  let count = 0
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) count++
    if (count >= digitIndex) return i + 1
  }
  return formatted.length
}
</script>
